import { render, staticRenderFns } from "./healthManual.vue?vue&type=template&id=f7f289aa&scoped=true&"
import script from "./healthManual.vue?vue&type=script&lang=js&"
export * from "./healthManual.vue?vue&type=script&lang=js&"
import style0 from "./healthManual.vue?vue&type=style&index=0&id=f7f289aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f289aa",
  null
  
)

export default component.exports